// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_AtualizaValorServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /compromissos/atualiza_valor_servico
 *
 * Updates the value of a compromisso servico (appointment service).
 * This endpoint returns null dados on success — operation success is
 * signaled by the envelope's `success` flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_AtualizaValorServicoResponseDados = null;

export type Compromissos_AtualizaValorServicoResponse = ApiResponse<Compromissos_AtualizaValorServicoResponseDados>;

registerResponseContract('Compromissos_AtualizaValorServicoResponse', {})
